/* eslint-disable */
// ============================================================
//  native-back.js — Bouton retour physique dans l'app installee.
//
//  Dans l'app Android (Capacitor), c'est le systeme qui traite le bouton
//  retour AVANT la page. Sans ce relais, il ferme purement et simplement
//  l'application : tout le travail fait cote site (pile d'ecrans, onglets,
//  etapes de publication, fenetre de confirmation) n'est jamais consulte.
//
//  On rend donc la main a la navigation du site, qui sait quoi faire.
//
//  ⚠️ NO-OP total sur le web normal et sur tout build natif ou le plugin
//  @capacitor/app est absent : zero impact sur le site.
// ============================================================

let started = false;

export function initNativeBack() {
  if (started) return;
  try {
    const Cap = typeof window !== "undefined" ? window.Capacitor : null;
    const App = Cap && Cap.Plugins && Cap.Plugins.App;
    if (!App || !App.addListener) return;   // navigateur, ou build sans le plugin
    started = true;

    App.addListener("backButton", (ev) => {
      // Capacitor nous dit s'il reste quelque chose a depiler. Quand il n'y a
      // plus rien, l'historique ne repondrait pas et l'utilisateur se
      // retrouverait coince : on sort explicitement.
      if (ev && ev.canGoBack === false) {
        try { App.exitApp && App.exitApp(); } catch (e) {}
        return;
      }
      // Sinon on repasse par l'historique : App.jsx y a branche toute la
      // logique (retour d'ecran, onglets, etapes, confirmation de sortie).
      try { window.history.back(); } catch (e) {}
    });
  } catch (e) {
    // Un echec ici ne doit jamais empecher l'app de demarrer.
  }
}
